import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a date string according to the specified format
 * @param {string} dateString - Date in 'yyyy-MM-dd' format
 * @param {string} dateFormat - Format string (DD/MM/YYYY, MM/DD/YYYY, YYYY-MM-DD, DD-MMM-YYYY)
 * @returns {string} Formatted date string
 */
export function formatDate(dateString, dateFormat = 'DD/MM/YYYY') {
  if (!dateString) return '-';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthShort = monthNames[date.getMonth()];
    
    switch (dateFormat) {
      case 'DD/MM/YYYY':
        return `${day}/${month}/${year}`;
      case 'MM/DD/YYYY':
        return `${month}/${day}/${year}`;
      case 'YYYY-MM-DD':
        return `${year}-${month}-${day}`;
      case 'DD-MMM-YYYY':
        return `${day}-${monthShort}-${year}`;
      default:
        return `${day}/${month}/${year}`;
    }
  } catch {
    return dateString;
  }
}

/**
 * Create a date formatter function that can be passed to DatePicker
 * @param {string} dateFormat - Format string from tenant settings
 * @returns {function} Formatter function
 */
export function createDateFormatter(dateFormat) {
  return (dateString) => formatDate(dateString, dateFormat);
}
